/**
 * Created by laszlo.czondor on 2017. 11. 20.
 */
import { CSATORNA_KIOSZTASOK } from '../../common/api/urls';
import getServices from '../../common/api/get-services';
import getMobiltvServices from '../../common/api/get-mobiletv-services';

export default {
	getChannels(serviceId) {
		return window.axios.get(`${CSATORNA_KIOSZTASOK}?szolgaltatasId=${serviceId}`);
	},
	getServices,
	getMobiltvServices
};



// WEBPACK FOOTER //
// ../source/modules/CHN01-channels/CHN01-channels.api.js